
import {
  defineComponent,
  ref,
  watch,
  PropType,
} from 'vue';

import SpmTable from '@/components/table/SpmTable.vue';

import { useI18n } from 'vue-i18n';

import {
  SpmTableState,
  SpmTableColumns,
} from '@/types';

export default defineComponent({
  name: 'ActiveCampaignsList',

  components: {
    SpmTable,
  },

  props: {
    campaigns: {
      type: Array as PropType<any[]>,
      required: true,
    },

    description: {
      type: String,
      required: false,
      default: '',
    },
  },

  setup(props: { campaigns: any[]; description: string }) {
    const { t } = useI18n();

    const campaignsData = ref<SpmTableState>({
      items: [],
      error: '',
      total: 0,
    });

    const columns: SpmTableColumns[] = [
      {
        field: 'name_campaign_automation',
        header: t('templateBuilder.saveSyncElementModal.activeCampaignsWarning.columnHeader'),
        sortable: false,
        filterable: false,
        editable: false,
        style: '',
        type: 'text',
      },
    ];

    watch(
      () => props.campaigns,
      (newCampaigns) => {
        // Deduplicate campaigns by name_campaign_automation
        const uniqueCampaigns = newCampaigns.filter(
          (campaign, index, self) =>
            index === self.findIndex((c) => c.name_campaign_automation === campaign.name_campaign_automation)
        );
        campaignsData.value = {
          items: uniqueCampaigns,
          error: '',
          total: uniqueCampaigns.length,
        };
      },
      { immediate: true },
    );

    return {
      t,
      campaignsData,
      columns,
    };
  },
});
